<section>
  <p>
    To avoid an unnecessarily big css file, all icons except the default black ones have to be
    explicitly declared in your scss file.
  </p>
  <h4>Example:</h4>
  <div class="row">
    <div class="col-2 mb-3"><strong>Rendered</strong></div>
    <div class="col-2"><strong>Applied classes</strong></div>
    <div class="col-4"><strong>Markup</strong></div>
    <div class="col-4"><strong>SASS</strong></div>
    <div class="col-2 mb-3 text-center">
      <i class="pi pi-1000" aria-hidden="true"></i>
    </div>
    <div class="col-2">pi pi-1000</div>
    <div class="col-4">
      <code>&lt;i class="pi pi-1000" aria-hidden="true"&gt;&lt;/i&gt;</code>
    </div>
    <div class="col-4">
      <code class="sass">// No additional SASS necessary</code>
    </div>
    <div class="col-2 mb-3 text-center">
      <i class="pi pi-1000-warning" aria-hidden="true"></i>
    </div>
    <div class="col-2">
      pi pi-1000-warning
      <br />
      <small>See available contextual colors below.</small>
    </div>
    <div class="col-4">
      <code>&lt;i class="pi pi-1000-warning" aria-hidden="true"&gt;&lt;/i&gt;</code>
    </div>
    <div class="col-4">
      <code class="sass">
        {{ cwfImport }}
        <br />
        .pi-1000-warning &#123;
        <br />
        &nbsp;&nbsp;&#64;include post.pi(1000, "warning");
        <br />
        &#125;
      </code>
    </div>
    <div class="col-2 mb-3 text-center">
      <i class="pi pi-heart" aria-hidden="true"></i>
    </div>
    <div class="col-2">pi pi-heart</div>
    <div class="col-4">
      <code>&lt;i class="pi pi-heart" aria-hidden="true"&gt;&lt;/i&gt;</code>
    </div>
    <div class="col-4">
      <code class="sass">
        {{ cwfImport }}
        <br />
        .pi-heart &#123;
        <br />
        &nbsp;&nbsp;&#64;include post.pi("2063", #FF0080);
        <br />
        &#125;
      </code>
    </div>
    <div class="col-2 mb-3 text-center">
      <i class="pi pi-heart-coral pi-border" aria-hidden="true"></i>
    </div>
    <div class="col-2">pi pi-heart-coral pi-border</div>
    <div class="col-4">
      <code>&lt;i class="pi pi-heart-coral pi-border" aria-hidden="true"&gt;&lt;/i&gt;</code>
    </div>
    <div class="col-4">
      <code class="sass">
        &#64;use "sass:map";
        <br />
        {{ cwfImport }}
        <br />
        .pi-heart-coral &#123;
        <br />
        &nbsp;&nbsp;&#64;include post.pi(2063, map.get(post.$background-colors, "coral"));
        <br />
        &#125;
      </code>
    </div>
  </div>
  <h4>Colors</h4>
  <p>
    Available placeholders for: Primary, White, Info, Danger, Success (Note: Named icons can not be
    colored.)
  </p>
  <section class="row">
    <div
      class="col-12 p-2"
      *ngFor="let color of colors"
      [ngClass]="color === 'white' ? 'bg-primary' : ''"
    >
      <div class="row">
        <div class="col-2 text-center">
          <i class="pi" [class]="'pi-1000-' + color" aria-hidden="true"></i>
        </div>
        <code class="col-5">
          &lt;i class="pi" [class]="'pi-1000-' + color" aria-hidden="true"&gt;&lt;/i&gt;
        </code>
        <code class="col-5 sass">
          {{ cwfImport }}
          <br />
          .pi-1000-{{ color }} &#123; &#64;include post.pi(1000, "{{ color }}"); &#125;
        </code>
      </div>
    </div>
    <div class="col-12 mt-3">
      Include a certain icon in all contextual colors (Example for pi-1000):
      <br />
      <code class="sass">
        {{ cwfImport }}
        <br />
        &#64;each $color, $value in post.$contextual-colors &#123;
        <br />
        &nbsp;&nbsp;.pi-1000-#&#123;$color&#125; &#123;
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&#64;include post.pi(1000, $color);
        <br />
        &nbsp;&nbsp;&#125;
        <br />
        &#125;
      </code>
    </div>
    <div class="col-12 mt-3">
      Include the entire icon set in a specific color (Example for Post-Color "Nightblue"):
      <br />
      <code class="sass">
        &#64;use "sass:map";
        {{ cwfImport }}
        <br />
        &#64;each $name, $path in post.$svg-icon-map &#123;
        <br />
        &nbsp;&nbsp;.pi-#&#123;$name&#125; &#123;
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&#64;include post.pi($name, map.get(post.$accent-colors, "nightblue"));
        <br />
        &nbsp;&nbsp;&#125;
        <br />
        &#125;
      </code>
    </div>
  </section>
  <h4>Available Adjustments</h4>
  <section class="row">
    <div class="col-2 text-center mb-3">
      <i class="pi pi-border pi-1000" aria-hidden="true"></i>
    </div>
    <div class="col-3">
      <strong>With border</strong>
    </div>
    <code class="col-7">&lt;i class="pi pi-border pi-1000"&gt;&lt;/i&gt;</code>
    <div class="col-2 text-center mb-3">
      <i class="pi pi-1000 pi-small" aria-hidden="true"></i>
    </div>
    <div class="col-3">
      <strong>Small</strong>
    </div>
    <code class="col-7">&lt;i class="pi pi-small pi-1000"&gt;&lt;/i&gt;</code>
    <div class="col-2 text-center mb-3">
      <i class="pi pi-1000 pi-2x" aria-hidden="true"></i>
    </div>
    <div class="col-3">
      <strong>2x</strong>
    </div>
    <code class="col-7">&lt;i class="pi pi-2x pi-1000"&gt;&lt;/i&gt;</code>
    <div class="col-2 text-center mb-3">
      <i class="pi pi-1000 pi-3x" aria-hidden="true"></i>
    </div>
    <div class="col-3">
      <strong>3x</strong>
    </div>
    <code class="col-7">&lt;i class="pi pi-3x pi-1000"&gt;&lt;/i&gt;</code>
    <div class="col-2 text-center mb-3">
      <i class="pi pi-1000 pi-4x" aria-hidden="true"></i>
    </div>
    <div class="col-3">
      <strong>4x</strong>
    </div>
    <code class="col-7">&lt;i class="pi pi-4x pi-1000" aria-hidden="true"&gt;&lt;/i&gt;</code>
  </section>
  <h4>All SVG Icons</h4>
  <p>
    If you need the digital post logo, please discuss your need with
    <a href="mailto:corpdesign@post.ch">CorpDesign, K21 [E-Mail Request]</a>
    .
  </p>
  <section class="row">
    <div class="col-auto mb-2 text-center" *ngFor="let iconName of preColored">
      <i class="pi" [class]="'pi-' + iconName" aria-hidden="true"></i>
      <br />
      <code class="text-dark mt-1">pi-{{ iconName }}</code>
    </div>
  </section>
  <section class="row">
    <div class="col-auto mb-2 text-center" *ngFor="let nr of range">
      <i class="pi" [class]="'pi-' + nr" aria-hidden="true"></i>
      <br />
      <code class="text-dark mt-1">pi-{{ nr }}</code>
    </div>
  </section>
</section>
